import { Box, Flex, Image } from "rebass";
import ErrorPlaceholder from "../components/ErrorPlaceholder";
import config from "../utils/globalConfig";
import { getLocalizedString, history, theme } from "../utils";
import facebookLogo from "../static/images/facebook.svg";
import twitterLogo from "../static/images/twitter-logo-white.png";
import pinterestLogo from "../static/images/pinterest.svg";
import instagramLogo from "../static/images/instagram.svg";
import logoImage from "../static/images/hernoLogo333.png";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { userActions } from "../logic/actions";

const Page403 = () => {
  const headerHeight = 50;

  const dispatch = useDispatch();

  const logout = () => {
    dispatch(userActions.logout());
  };

  useEffect(() => {
    if (history.location.state?.authError) {
      console.warn(
        `B2B Authorization error: ${history.location.state.authError}`,
      );
    }
    if (history.location.state?.yodaError) {
      console.warn(`Yoda Authorization error`);
    }
    if (history.location.state?.roleError) {
      console.warn(`incompatible role`);
    }
  }, []);
  return (
    <Flex
      width={1}
      height={"100dvh"}
      minHeight={"100dvh"}
      flexDirection={"column"}
      bg={theme.backgroundPrimary}
    >
      <Flex
        width="100%"
        height={headerHeight}
        maxHeight={headerHeight}
        bg={theme.background}
        justifyContent="center"
        alignItems="center"
      >
        <Flex
          height={"100%"}
          justifyContent="center"
          onClick={() => history.replace("/homepage")}
        >
          <img
            alt="Herno Logo"
            src={logoImage}
            p={4}
            style={{
              objectFit: "scale-down",
            }}
          />
        </Flex>
      </Flex>
      <Flex flexGrow={1} justifyContent="center">
        <Flex width={1} flexDirection="column">
          <Flex
            width={[1, null, null, 1]}
            maxWidth={config.VIEWPORT}
            flexDirection="column"
            style={{
              marginLeft: "auto",
              marginRight: "auto",
            }}
            flexGrow={1}
          >
            <ErrorPlaceholder
              message={getLocalizedString("ERROR_403")}
              button={{
                label: "OK",
                onClick: () => {
                  history.replace("/homepage");
                  window.location.reload();
                },
              }}
            />
            <Box
              fontSize={["14px", "18px"]}
              textAlign={"center"}
              paddingBottom={"20px"}
            >
              <Box
                display={"inline"}
                fontWeight={600}
                sx={{ textTransform: "uppercase", cursor: "pointer" }}
                onClick={logout}
              >
                {getLocalizedString("403_LOGOUT_CTA")}
              </Box>
            </Box>
          </Flex>
          <Flex
            flexGrow={1}
            height={[100, null, null, 50]}
            maxHeight={[100, null, null, 50]}
            bg={theme.background}
            alignItems="center"
            mt={10}
            pt={10}
            pl={[0, null, 150]}
            pr={[0, null, 150]}
            pb={10}
            fontSize={"0.6em"}
            justifyContent="center"
            color="white"
            flexDirection={["column", null, "row"]}
          >
            <Flex
              width={[1, null, 1 / 4]}
              alignItems="center"
              justifyContent="center"
            ></Flex>
            <Flex
              width={[1, null, 2 / 4]}
              alignItems="center"
              justifyContent="center"
              p={2}
            >
              COPYRIGHT &copy; HERNO S.P.A {new Date().getFullYear()} - ALL
              RIGHTS RESERVED
            </Flex>
            <Flex
              width={[1, null, 1 / 4]}
              alignItems="center"
              justifyContent="center"
            >
              <a
                style={{ textDecoration: "none" }}
                href="https://www.facebook.com/HernoSpa/"
                target="_blank"
                rel="noreferrer"
              >
                <Image src={facebookLogo} m={2} height={21}></Image>
              </a>

              <a
                style={{ textDecoration: "none" }}
                href="https://twitter.com/Herno_official"
                target="_blank"
                rel="noreferrer"
              >
                <Image src={twitterLogo} m={2} height={21}></Image>
              </a>

              <a
                style={{ textDecoration: "none" }}
                href="https://www.instagram.com/herno_official/"
                target="_blank"
                rel="noreferrer"
              >
                <Image src={instagramLogo} m={2} height={21}></Image>
              </a>

              <a
                style={{ textDecoration: "none" }}
                href="https://www.pinterest.it/hernospa/"
                target="_blank"
                rel="noreferrer"
              >
                <Image src={pinterestLogo} m={2} height={21}></Image>
              </a>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default Page403;
